import { Button } from "@material-ui/core";
import React, { useRef, useEffect, useState } from "react";

const LS_NAME = 'audioMessageRate';

export default function Audio({ url }) {
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState(parseFloat(localStorage.getItem(LS_NAME) || "1"));
    const [showButtonRate, setShowButtonRate] = useState(false);
    const [audioUrl, setAudioUrl] = useState("");

    // Build the full URL
    useEffect(() => {
        const baseUrl = process.env.REACT_APP_BACKEND_URL || "";
        const fullUrl = url.startsWith("http") 
            ? url 
            : `${baseUrl}/public/${url}`;
        
        setAudioUrl(fullUrl);
    }, [url]);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.playbackRate = audioRate;
            localStorage.setItem(LS_NAME, audioRate);
        }
    }, [audioRate]);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        const handlePlaying = () => setShowButtonRate(true);
        const handlePause = () => setShowButtonRate(false);
        const handleEnded = () => setShowButtonRate(false);

        audio.addEventListener('playing', handlePlaying);
        audio.addEventListener('pause', handlePause);
        audio.addEventListener('ended', handleEnded);

        return () => {
            audio.removeEventListener('playing', handlePlaying);
            audio.removeEventListener('pause', handlePause);
            audio.removeEventListener('ended', handleEnded);
        };
    }, []);

    const toogleRate = () => {
        let newRate = null;

        switch (audioRate) {
            case 0.5:
                newRate = 1;
                break;
            case 1:
                newRate = 1.5;
                break;
            case 1.5:
                newRate = 2;
                break;
            case 2:
                newRate = 0.5;
                break;
            default:
                newRate = 1;
                break;
        }

        setAudioRate(newRate);
    };

    return (
        <>
            <audio 
                ref={audioRef} 
                controls
                preload="metadata"
                style={{ maxWidth: '250px', width: '100%' }}
            >
                <source src={audioUrl} type="audio/m4a" />
                <source src={audioUrl} type="audio/mp4" />
                <source src={audioUrl} type="audio/mpeg" />
                <source src={audioUrl} type="audio/ogg" />
                Your browser does not support the audio element.
            </audio>
            {showButtonRate && (
                <Button 
                    style={{ marginLeft: "5px", marginTop: "-45px" }} 
                    onClick={toogleRate}
                >
                    {audioRate}x
                </Button>
            )}
        </>
    );
}